import axios from "axios";
// import { ConsoleLogs } from "../../utils/ConsoleLogs";


export const ApiCallPost = async (url, parameters, headers, responseType) => {
  try {
    const response = await axios.post(url, parameters, { headers: headers, responseType });
    // ConsoleLogs(
    //     TAG + ", ApiCallPost",
    //     `apiDebug, response: ${JSON.stringify(response.data)}`,
    // );
    return response.data;
  } catch (error) {
    // ConsoleLogs(
    //     TAG + ",ApiCallPost",
    //     `apiDebug, response error: ${JSON.stringify(error.response.data.message)}`,
    // );
    return error.response.data;
  }

};



export const ApiCallGet = async (url, params, headers, responseType) => {
  try {
    const response = await axios.get(url, {
      params: params,
      responseType: responseType,
      headers: headers,
    });

    if (response && response.data) {
      // ConsoleLogs(
      //   TAG + ", ApiCallGet",
      //   `apiDebug, response: ${JSON.stringify(response.data)}`,
      // );
      return response.data;
    } else {
      // ConsoleLogs(
      //   TAG + ", ApiCallGet",
      //   "apiDebug, response error: Response data is undefined or empty.",
      // );
      throw new Error("Response data is undefined or empty.");
    }
  } catch (error) {
    if (error.response && error.response.data) {
      // ConsoleLogs(
      //   TAG + ", ApiCallGet",
      //   `apiDebug, response error: ${JSON.stringify(error.response.data.message)}`,
      // );
      return error.response.data;
    } else if (error.message === "Network Error") {
      // ConsoleLogs(
      //   TAG + ", ApiCallGet",
      //   "apiDebug, network error: There was a problem with the network.",
      // );

    } else {
      // ConsoleLogs(
      //   TAG + ", ApiCallGet",
      //   `apiDebug, response error: ${JSON.stringify(error.message)}`,
      // );

    }
    throw error;
  }
};


export const ApiCallPut = async (url, parameters, headers) => {
  try {
    const response = await axios.put(url, parameters, { headers: headers });
    // ConsoleLogs(
    //     TAG + ", ApiCallPost",
    //     `apiDebug, response: ${JSON.stringify(response.data)}`,
    // );
    return response?.data;
  } catch (error) {
    // ConsoleLogs(
    //     TAG + ",ApiCallPost",
    //     `apiDebug, response error: ${JSON.stringify(error.response.data.message)}`,
    // );
    return error.response?.data;
  }

};



export const ApiCallDelete = async (url, data, headers) => {
  try {
    const response = await axios.delete(url, { data, headers });
    return response.data;
  } catch (error) {
    if (error.response) {

      // console.error("Response data:", error.response.data);
      // console.error("Status code:", error.response.status);
      // console.error("Headers:", error.response.headers);
    } else if (error.request) {

      // console.error("Request:", error.request);
    } else {

      // console.error("Error:", error.message);
    }
    return { success: false, message: error?.response?.data?.message };
  }
};